/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.list.modal.controllers', [
  'ui.router',
  'ui.bootstrap'
])
.controller('PosListModalController', ['$scope','$uibModalInstance', '$state', 'configItem', 'terminals', function($scope, $uibModalInstance, $state, configItem, terminals) {
  $scope.posListModal = {
    
    name: configItem.name,
    terminals: terminals.data.payload || [],
    
    confirm: function () {
      $uibModalInstance.close(true);
    },
    
    formatName: function (terminal) {
       return terminal.name || '(' + terminal.terminalId + ')' || '(' + terminal.id + ')';
    },
    
    seletedTerminal: function (id) {
      $state.go('application.settings.terminals', {  terminalId: id });
      $uibModalInstance.dismiss('cancel');
    },
    
    close: function () {
      $uibModalInstance.dismiss('cancel');
    }
    
  };

}]);